import {
  Box,
  Paper,
  type PaperProps,
  Stack,
  Text,
  type TextProps,
} from '@mantine/core';
import clsx from 'clsx';
import type { MouseEventHandler, ReactNode } from 'react';
import classes from './ActionCard.module.css';

type ActionCardProps = PaperProps & {
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  titleProps?: Omit<TextProps, 'children'>;
  descriptionProps?: Omit<TextProps, 'children'>;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

function ActionCard({
  leftSection,
  rightSection,
  title,
  description,
  titleProps,
  descriptionProps,
  onClick,
  className,
  ...paperProps
}: ActionCardProps) {
  return (
    <Paper
      p="lg"
      radius="md"
      withBorder
      {...paperProps}
      className={clsx(onClick && classes.clickable, className)}
      onClick={onClick}
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? 'button' : undefined}
    >
      <Box className={classes.inner}>
        <Box className={classes.leftGroup}>
          {leftSection}
          <Stack gap={2}>
            {title && (
              <Text fw={600} size="sm" {...titleProps}>
                {title}
              </Text>
            )}
            {description && (
              <Text size="xs" c="dimmed" {...descriptionProps}>
                {description}
              </Text>
            )}
          </Stack>
        </Box>
        {rightSection}
      </Box>
    </Paper>
  );
}

export { ActionCard, type ActionCardProps };
